import React from 'react'
import {Option, OptionContainer, QuestionContainer} from "../common"
import Text from "../../../../common/components/Text"

const DoctorConfirm = ({first, doctor, finished, setDoctorTag}) => (
  <QuestionContainer first={first}>
    <Text fontWeight="regular">
      {first ?
        'Have you talked to a doctor about your symptoms?' :
        'Has a doctor confirmed this diagnosis?'}
    </Text>
    <OptionContainer>
      <Option disabled={finished} selected={doctor === "Yes"} onClick={() => setDoctorTag("Yes")}>Yes</Option>
      <Option disabled={finished} selected={doctor === "No"} onClick={() => setDoctorTag("No")}>No</Option>
    </OptionContainer>
  </QuestionContainer>
)

export {DoctorConfirm as default}



// WEBPACK FOOTER //
// ./assets/feedback/components/tagging/components/DoctorConfirm.js